import { render, staticRenderFns } from "./ProductsSwitch.vue?vue&type=template&id=1b22843d&lang=pug&"
import script from "./ProductsSwitch.vue?vue&type=script&lang=js&"
export * from "./ProductsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports